import React from "react";
import Graphs from "./Graphs";
import News from "./News";
import StockSelector from "./StockSelector";
import { DashboardContainer } from "./styles";

function Dashboard() {
  const [selectedStock, setSelectedStock] =
    React.useState(false);
  return (
    <DashboardContainer>
      <Graphs selectedStock={selectedStock} />
      <News selectedStock={selectedStock} />
      <StockSelector
        selectedStock={selectedStock}
        setSelectedStock={setSelectedStock}
      />
    </DashboardContainer>
  );
}
export default Dashboard;
